import { ConvertPackageDuration } from "@/utils/convert-package-duration";
import { PackageDetailsProps } from "./package-details.types";
import { ConvertProductToName } from "@/utils/convert-product-to-name";
import { formatInTimeZone } from "date-fns-tz";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const PackageDetails = ({
  selectedPackage,
  packageGroups,
  className = "",
}: PackageDetailsProps) => {
  const detailRows = [
    {
      items: [
        {
          label: "ID do pacote",
          value: String(selectedPackage?.id || ""),
        },
        {
          label: "Data de início",
          value: formatInTimeZone(
            selectedPackage?.versions[0].startDate,
            "UTC",
            "dd/MM/yyyy",
          ),
        },
        {
          label: "Data de fim",
          value: formatInTimeZone(
            selectedPackage?.versions[selectedPackage.versions.length - 1]
              .endDate,
            "UTC",
            "dd/MM/yyyy",
          ),
        },
      ],
    },
    {
      items: [
        {
          label: "Produtos",
          value:
            selectedPackage?.products
              ?.map((product) => ConvertProductToName(product))
              .join(", ") || "",
        },
      ],
    },
    {
      items: [
        {
          label: "Grupos",
          value:
            packageGroups?.map((group) => group.name).join(", ") ||
            "Company wide",
        },
      ],
    },
    {
      items: [
        {
          label: "Duração do ciclo",
          value: selectedPackage?.duration
            ? ConvertPackageDuration(selectedPackage.duration) || "Mensal"
            : "Mensal",
        },
      ],
    },
  ];

  return (
    <div className={className}>
      <CardHeader className="px-4 py-6">
        <CardTitle className="text-bg-black text-2xl font-medium leading-relaxed">
          Pacote
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0 w-full overflow-hidden">
        {detailRows.map((row, rowIndex) => {
          return (
            <div
              key={rowIndex}
              className={`grid border-t-2 grid-cols-${row.items.length}`}
            >
              {row.items.map((item, itemIndex) => (
                <div
                  key={item.label}
                  className={`p-3 ${
                    itemIndex < row.items.length - 1 ? "border-r-2" : ""
                  }`}
                >
                  <div className="flex flex-col gap-1">
                    <div className="text-sm font-semibold">{item.value}</div>
                    <div className="text-sm text-muted-foreground">
                      {item.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </CardContent>
    </div>
  );
};
